<template>
    <div class="header">
        <div @click="goIndex" class="logo" v-if="type==2">
            <img src="../assets/imgs/logo.png" alt="">
            <span>中富金石</span>
        </div>
        <div :style="logoStyle" @click="goIndex" class="logo1" v-if="type==1||type==3">
            <img src="../assets/imgs/logo1.png" alt="">
            <span>中富金石</span>
        </div>
        <div v-if="isPc">
            <div class="menu" @click="showMenu" v-if="type==2">
                <span>导航</span>
                <img src="../assets/imgs/menu.png" alt="">
            </div>
            <div class="menu1" @click="showMenu" v-if="type==3">
                <span>导航</span>
                <img src="../assets/imgs/menu1.png" alt="">
            </div>
        </div>
        <div v-if="!isPc">
            <div class="menu" @click="showMenu" v-if="type==2">
                <span>导航</span>
                <img src="../assets/imgs/menu.png" alt="">
            </div>
            <div class="menu1" @click="showMenu" v-if="type==3||type==1">
                <span>导航</span>
                <img src="../assets/imgs/menu1.png" alt="">
            </div>
        </div>
        <div class="ul" v-if="type==1">
            <div class="li" @click="goIndex">首页</div>
            <div v-if="index<MenuList.length-1" :class="index==navIdx?'li1':'li'" v-for="(item, index) in MenuList" :key="index" @click="goPage(item)">
                {{item.columnName}}</div>
            <div :class="navIdx==100?'li3':'li2'">
                <div class="tp" @click="liShow=!liShow">
                    {{lastMenu.columnName}}
                    <img src="../assets/imgs/down.png" alt="">
                </div>
                <div class="bm" v-if="liShow">
                  <div v-for="(item, index) in this.lastMenu.children">
                    <div @click="goCheckPage(lastMenu.children[index].id)">{{lastMenu.children[index].columnName}}</div>
                  </div>
                    <!-- <div @click="goCheckPage(lastMenu.children[0].id)">{{lastMenu.children[0].columnName}}</div>
                    <div @click="goCheckPage(lastMenu.children[1].id)">{{lastMenu.children[1].columnName}}</div>
                    <div @click="goCheckPage(lastMenu.children[2].id)">{{lastMenu.children[2].columnName}}</div> -->
                </div>

            </div>
        </div>
        <Transition name="bounce">
            <div v-if="maskShow" class="mask">
                <div class="close" @click="closeMenu">
                    <img src="../assets/imgs/close.png" alt="">
                </div>
                <div class="con">
                    <div class="item" v-for="(item, index) in MenuList" :key="index" @mouseenter="showMore(item,index)" @mouseleave="hideMore(item,index)">
                        <div class="title" @click="goPage(item)">
                            <div class="t">{{item.columnName}}</div>
                            <div class="b">{{item.englishName}}</div>
                        </div>
                        <Transition name="more">
                            <div v-if="moreShow&&showId==index&&item.children" class="more">
                                <div @click="goPageIdx(item,itm)" v-for="(itm,idx) in item.children" :key="idx" >{{itm.columnName}}</div>
                            </div>
                        </Transition>
                    </div>
                </div>
            </div>
        </Transition>
        <Transition name="black">
            <div v-if="maskShow" class="black"></div>
        </Transition>
    </div>
</template>
<script>
import { getMenu } from "../api/index"
export default {
    name: 'navHeader',
    props: {
        type: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            logoStyle:'',
            showId:-1,
            isPc: 1,
            MenuList: [],
            lastMenu:{children:[{columnName:""},{columnName:""}]},
            navIdx: -1,
            maskShow: false,
            moreShow: false,
            liShow: false,
        }
    },
    watch: {
        '$store.state.isPc'(newVal, oldVal) {
            this.isPc = newVal
            console.log(this.isPc)
        }
    },
    created() {
        var userAgentInfo = navigator.userAgent;
        var Agents = ["Android", "iPhone",
            "SymbianOS", "Windows Phone", "iPod"];
        var isPc = true;
        for (var v = 0; v < Agents.length; v++) {
            if (userAgentInfo.indexOf(Agents[v]) > 0) {
                isPc = false;
                break;
            }
        }
        if (isPc) {
            this.isPc = 1
            this.$store.commit('setIspc', 1)

        } else {
            this.isPc = 0
            this.$store.commit('setIspc', 0)


        }
        this.getMenus()

    },
    mounted() {
        if(this.$store.state.isPc){
            window.addEventListener('scroll', this.handleScroll)
        }
        var title = this.$route.path
        if(title.slice(0,7)=="/article"){
            if(title.slice(8,100)==1||title.slice(8,100)==2){
                this.navIdx=2
                return
            }
            this.navIdx=1
        }
        if(title=="/staff"||title=="/firm"){
            this.navIdx=100
        }
    },
    methods: {
        handleScroll(){
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            if(scrollTop==0){
                this.logoStyle=''
            }else{
                this.logoStyle='transform: scale(0.7);'
            }

        },
        getMenus() {
            if (this.$store.state.menuList.length == 0) {
                // 获取菜单
                getMenu().then((res) => {
                    var now = res.rows
                    now.forEach((item, index) => {
                        if (this.$route.path == item.url) {
                            this.navIdx = index
                        }
                    });
                    this.MenuList = now
                    this.lastMenu=now[now.length-1]
                    this.$store.commit("setMenu", now)

                }).catch(err => {
                    console.log(err)
                })

            } else {
                this.MenuList = this.$store.state.menuList
                this.MenuList.forEach((item, index) => {
                    if (this.$route.path == item.url) {
                        this.navIdx = index
                    }
                });
                this.lastMenu=this.MenuList[this.MenuList.length-1]
            }
        },
        showMore(item,index){
            this.showId=index
            this.moreShow=true

        },
        hideMore(item,index){
            this.showId=-1
            this.moreShow=false

        },
        goIndex() {


            this.$router.push("/")

        },
        goCheckPage(id){
            if(id==20){
                this.$router.push("/staff")
                return
            }
            if(id==21){
                this.$router.push("/firm")
                return
            }
            if(id==56){
                this.$router.push("/Product")
                return
            }
        },
        // 跳转页面
        goPage(item) {
            if (this.$route.path == item.url) {
                location.reload()
                return
            }
            this.$router.push({path: item.url})

        },
        goPageIdx(item,itm){
            if (this.$route.path == item) {
                location.reload()
                return
            }
            if(itm.id==20){
                this.$router.push("/staff")
                return
            }
            if(itm.id==21){
                this.$router.push("/firm")
                return
            }
            if(itm.id==56){
                this.$router.push("/Product")
                return
            }
            this.$router.push({path: item.url,query:{cid:itm.id}})
        },
        // 展示菜单
        showMenu() {
            this.maskShow = true
        },
        // 收起菜单
        closeMenu() {
            this.maskShow = false
        }

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.header {
    z-index: 2;
    position: absolute;
    width: 100%;
    padding: 0.24rem 0.36rem;
    display: flex;
    justify-content: space-between;

    .logo {
        cursor: pointer;
        display: flex;
        align-items: center;
        font-size: 0.36rem;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;

        img {
            width: 0.48rem;
            height: 0.48rem;
        }

        span {
            padding-left: 0.24rem;
        }
    }

    .logo1 {
        transition: all 0.3s ease;
        cursor: pointer;
        display: flex;
        align-items: center;
        font-size: 0.36rem;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #000000;

        img {
            width: 0.48rem;
            height: 0.48rem;
        }

        span {
            padding-left: 0.24rem;
        }
    }

    .menu {
        cursor: pointer;
        display: flex;
        align-items: center;

        img {
            width: 0.36rem;
            height: 0.36rem;
        }

        span {
            font-size: 0.21rem;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            padding-right: 0.24rem;
        }
    }

    .menu1 {
        cursor: pointer;
        display: flex;
        align-items: center;

        img {
            width: 0.36rem;
            height: 0.36rem;
        }

        span {
            font-size: 0.21rem;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #000000;
            padding-right: 0.24rem;
        }
    }

    .ul {
        display: flex;
        align-items: center;

        .li {
            margin-right: 0.6rem;
            font-size: 0.21rem;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.85);
            cursor: pointer;
        }
        .li2 {
            font-size: 0.21rem;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.85);
            cursor: pointer;
            position: relative;
            .tp:hover{
            color: #3559C7;
        }

            img {
                width: 0.24rem;
                margin-left: 0.1rem;
            }

            .bm {

                width: 100%;
                position: absolute;
                background: #fff;

                div {
                    text-align: center;
                    padding: 0.15rem 0.1rem;
                }

            }
            .bm>div:hover{
            color: #3559C7;
        }
        }
        .li3 {
            font-size: 0.21rem;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.85);
            cursor: pointer;
            position: relative;
            .tp{
            color: #3559C7;
        }

            img {
                width: 0.24rem;
                margin-left: 0.1rem;
            }

            .bm {

                width: 100%;
                position: absolute;
                background: #fff;

                div {
                    text-align: center;
                    padding: 0.15rem 0.1rem;
                }

            }
            .bm>div:hover{
            color: #3559C7;
        }
        }

        .li:hover {
            color: #3559C7;
        }

        .li1 {
            margin-right: 0.6rem;
            font-size: 0.21rem;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 600;
            color: #3559C7;
            cursor: pointer;
        }

        .li1:hover {
            color: #3559C7;
        }
    }
}

.black {
    z-index: 100;
    position: fixed;
    right: 0;
    top: 0;
    width: 150vw;
    height: 150vh;
    background: #000;
}

.mask {
    z-index: 101;
    position: fixed;
    left: 0;
    top: 0;
    height: 100vh;
    width: 100vw;

    .close {
        cursor: pointer;
        z-index: 3;
        position: absolute;
        right: 0.36rem;
        top: 0.36rem;
        width: 0.36rem;
        height: 0.36rem;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .con {
        position: absolute;
        z-index: 2;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: space-evenly;
        align-items: center;

        .item {
            overflow: hidden;
            white-space: nowrap;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .title {
                cursor: pointer;

                .t {
                    font-size: 0.36rem;
                    font-family: PingFang SC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #FFFFFF;
                    margin-bottom: 0.12rem;
                }

                .b {
                    font-size: 0.21rem;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: rgba(255, 255, 255, 0.5);
                }

            }

            .more {
                margin-top: 0.4rem;
                width: 100%;
                text-align: left;
                font-size: 0.21rem;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                letter-spacing: 0.02rem;
                height: 2rem;
                display: flex;
                flex-direction: column;
                cursor: pointer;
                div{
                    padding-bottom: 0.2rem;
                }
            }
        }
    }
}

@media (max-width:500px) {
    .header {
        padding: 0.8rem 0.32rem 0.16rem;

        .logo {
            cursor: pointer;
            font-size: 0.34rem;
        }

        .logo1 {
            transition: all 0.3s ease;
            cursor: pointer;
            font-size: 0.34rem;
        }

        .menu {
            img {
                width: 0.42rem;
                height: 0.42rem;
            }

            span {
                font-size: 0.28rem;
                padding-right: 0.34rem;
            }
        }

        .menu1 {
            img {
                width: 0.42rem;
                height: 0.42rem;
            }

            span {
                font-size: 0.28rem;
                padding-right: 0.34rem;
            }
        }

        .ul {
            display: none;
        }
    }

    .black {
        z-index: 100;
        position: fixed;
        right: 0;
        top: 0;
        width: 120vw;
        height: 120vh;
        background: #000;
    }

    .mask {
        .close {
            right: 0.32rem;
            top: 0.8rem;
            width: 0.48rem;
            height: 0.48rem;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .con {
            position: absolute;
            z-index: 2;
            top: 2.08rem;
            width: 100%;
            height: 9.12rem;
            display: flex;
            padding-left: 0.8rem;
            flex-direction: column;
            align-items: flex-start;

            .item {
                overflow: hidden;
                white-space: nowrap;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;

                .title {
                    cursor: pointer;

                    .t {
                        font-size: 0.48rem;
                        margin-bottom: 0.16rem;
                    }

                    .b {
                        font-size: 0.28rem;
                    }

                }

                .more {
                    display: none;
                }
            }
        }
    }
}

.more-enter-active {
    animation: more-in 0.3s;
}

.more-leave-active {
    animation: more-in 0.3s reverse;
}

@keyframes more-in {
    0% {
        // left:100%;
        opacity: 0;
        height: 0;
    }

    100% {
        // left:0;
        opacity: 1;
        height: 2rem;
    }
}

.bounce-enter-active {
    animation: bounce-in 0.5s;
}

.bounce-leave-active {
    animation: bounce-in 0.5s reverse;
}

@keyframes bounce-in {
    0% {
        // left:100%;
        opacity: 0;
    }

    100% {
        // left:0;
        opacity: 1;
    }
}

.black-enter-active {
    animation: black-in 0.5s;
}

.black-leave-active {
    animation: black-in 0.5s reverse;
}

@keyframes black-in {
    0% {
        width: 0;
        height: 0;
        border-radius: 0 0 0 6rem;
    }

    100% {
        width: 150vw;
        height: 150vh;
        border-radius: 0 0 0 0rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue